/* =========================================================================
   Monk infinite scroll — replaces the numbered pagination on collection
   pages. Loads the next page silently as the visitor scrolls and appends
   the products (uses Shopify's Section Rendering API). No app needed.

   Works with: the theme's .collection__products .js-grid structure and its
   custom pagination (ul.pagination-custom). Safe no-op elsewhere.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__monkScroll) return;
  window.__monkScroll = true;

  var SEL_GRID = '.collection__products .js-grid';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // collection pages: product grid
    var grid = document.querySelector(SEL_GRID);
    var pag = grid ? document.querySelector('.pagination-custom') : null;

    // search pages: plain list of results (div.grid rows) + pagination after them
    var list = null;
    if (!grid && document.body && document.body.className.indexOf('template-search') !== -1) {
      var firstItem = document.querySelector('.collection__products div.grid');
      if (firstItem && firstItem.parentNode) {
        list = firstItem.parentNode;
        pag = document.querySelector('.pagination-custom');
      }
    }
    if ((!grid && !list) || !pag) return;

    var sectionEl = pag.closest('[id^="shopify-section-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    var busy = false;
    var done = false;
    var fails = 0;

    // hide the classic pagination; show a spinner sentinel under the grid
    var pagHolder = pag.closest('.text-center') || pag;
    pagHolder.style.display = 'none';

    var style = document.createElement('style');
    style.textContent =
      '.monk-scroll-sentinel{display:flex;justify-content:center;align-items:center;height:70px}' +
      '.monk-scroll-sentinel .monk-scroll-spin{width:26px;height:26px;border:2px solid #c7c8ca;border-top-color:#323233;border-radius:50%;opacity:0;transition:opacity .15s;animation:monk-scroll-rot .59s linear infinite}' +
      '.monk-scroll-sentinel.is-loading .monk-scroll-spin{opacity:1}' +
      '@keyframes monk-scroll-rot{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    var sentinel = document.createElement('div');
    sentinel.className = 'monk-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.innerHTML = '<span class="monk-scroll-spin"></span>';
    /* the sentinel sits exactly where the (hidden) pagination was — that is
       the real "end of the results" spot on both collection and search pages */
    pagHolder.parentNode.insertBefore(sentinel, pagHolder);

    function currentNextLink() {
      var p = document.querySelector('.pagination-custom');
      if (!p) return null;
      var arrs = p.querySelectorAll('.pagination-custom__arr');
      var last = arrs[arrs.length - 1];
      return last ? last.querySelector('a') : null;
    }

    function finish() {
      done = true;
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    }

    function appendResults(root) {
      if (grid) {
        var newGrid = root.querySelector('.collection__products .js-grid') || root.querySelector('.js-grid');
        if (!newGrid) return false;
        var kids = [].slice.call(newGrid.children);
        for (var i = 0; i < kids.length; i++) grid.appendChild(kids[i]);
        return true;
      }
      var newItems = root.querySelectorAll('.collection__products div.grid');
      if (!newItems.length) return false;
      if (list.lastElementChild && list.lastElementChild.tagName !== 'HR') {
        list.appendChild(document.createElement('hr'));
      }
      for (var j = 0; j < newItems.length; j++) list.appendChild(newItems[j]);
      return true;
    }

    function loadNext() {
      if (busy || done) return;
      var a = currentNextLink();
      if (!a) { finish(); return; }
      busy = true;
      sentinel.classList.add('is-loading');

      var url = a.getAttribute('href');
      if (sectionId) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      }

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          fails = 0;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var root = (sectionId && doc.getElementById('shopify-section-' + sectionId)) || doc;
          var newPag = root.querySelector('.pagination-custom');
          if (!appendResults(root)) { finish(); return; }

          if (newPag) {
            pag.replaceWith(newPag);
            pag = newPag;
          }

          // stop when the new pagination has no working "next" arrow
          var arrs = newPag ? newPag.querySelectorAll('.pagination-custom__arr') : null;
          var last = arrs && arrs.length ? arrs[arrs.length - 1] : null;
          if (!last || !last.querySelector('a')) finish();
        })
        .catch(function (err) {
          fails++;
          if (window.console && console.warn) console.warn('[monk-scroll]', err && err.message ? err.message : err);
          // if loading keeps failing, give the visitor the normal page links back
          if (fails >= 2) pagHolder.style.display = '';
        })
        .then(function () {
          busy = false;
          sentinel.classList.remove('is-loading');
          /* keep loading while the sentinel is still near the viewport
             (short pages need more than one batch to fill the screen) */
          if (!done && sentinel.parentNode) {
            var r = sentinel.getBoundingClientRect();
            if (r.top < window.innerHeight + 800) loadNext();
          }
        });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { loadNext(); break; }
        }
      }, { rootMargin: '800px 0px' });
      io.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        var r = sentinel.getBoundingClientRect();
        if (r.top < window.innerHeight + 800) loadNext();
      }, { passive: true });
    }
  });
})();
